import type { AxiosError } from 'axios';
import datadogLogger from './logger';

export const checkAxiosError = <T = unknown>(err: AxiosError<T>, loggerMessage?: string) => {
  datadogLogger.logger.error(
    loggerMessage ?? 'Application error',

    err.response
      ? {
          response: {
            data: err.response.data,
            status: err.response.status,
            statusText: err.response.statusText,
          },
        }
      : {},
    err
  );

  // client received an error response (5xx, 4xx)
  if (err.response)
    return {
      success: false,
      data: err.response.data,
      status: err.response.status,
      message: 'There was an error with your request.',
    } as const;

  // client never received a response, or request never left
  if (err.request)
    return {
      success: false,
      data: null,
      message: 'An unexpected error has occurred. Please check your connection.',
    } as const;

  // anything else
  return {
    success: false,
    data: null,
    message: 'An unexpected error has occurred.',
  } as const;
};
